/* @ts-ignore */
import * as Types from '../generated/graphql.g';

import { useMutation, UseMutationOptions } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type SetPrimaryResourceMutationVariables = Types.Exact<{
  resourceId: Types.Scalars['ID']['input'];
}>;


export type SetPrimaryResourceMutation = { __typename: 'Mutation', setPrimaryResource?: { __typename: 'SetPrimaryResourceMutation', success?: boolean | null, errors?: Array<string | null> | null, resource?: { __typename: 'ResourceType', id: string, productName?: string | null, vendorName?: string | null, isPrimaryResource: boolean, resourceGroup?: { __typename: 'ResourceGroupType', id: string } | null } | null } | null };



export const SetPrimaryResourceDocument = `
    mutation SetPrimaryResource($resourceId: ID!) {
  setPrimaryResource(resourceId: $resourceId) {
    success
    errors
    resource {
      id
      productName
      vendorName
      isPrimaryResource
      resourceGroup {
        id
      }
    }
  }
}
    `;

export const useSetPrimaryResourceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetPrimaryResourceMutation, TError, SetPrimaryResourceMutationVariables, TContext>) => {
    
    return useMutation<SetPrimaryResourceMutation, TError, SetPrimaryResourceMutationVariables, TContext>(
      {
    mutationKey: ['SetPrimaryResource'],
    mutationFn: (variables?: SetPrimaryResourceMutationVariables) => fetcher<SetPrimaryResourceMutation, SetPrimaryResourceMutationVariables>(SetPrimaryResourceDocument, variables)(),
    ...options
  }
    )};


useSetPrimaryResourceMutation.fetcher = (variables: SetPrimaryResourceMutationVariables) => fetcher<SetPrimaryResourceMutation, SetPrimaryResourceMutationVariables>(SetPrimaryResourceDocument, variables);
